define([
	"canvas/widgets/interfaces/model/enumerations/PlaceholderTextFormat",
	"./_PlaceholderTextFormat",
	"./PluginFactory"
], function({PlaceholderTextFormat}, _PlaceholderTextFormat, PluginFactory) {

	return PluginFactory.declare(_PlaceholderTextFormat, {
		"class": "csi-button-toggle",
		enumValue: PlaceholderTextFormat.LABEL,
		label: "Labels",
		pluginName: "PlaceholderTextLabel",
		showLabel: true,
		title: "CanvasLabels",

		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			const placeholderTextFormat = this.editor.canvasApp.pageHelper.getPlaceholderTextFormat();
			this.set("checked", this.enumValue === placeholderTextFormat);
			return true;
		},
	});
});
